import { createContext } from 'react';
import { ICorpUI } from 'src/types/Corp';

export interface SelfServiceCorporateDataContextType {
  corpData: ICorpUI | null;
  isLoading: boolean;
  hasError: boolean;
  refetch: () => void;
}

export const SelfServiceCorporateDataContext =
  createContext<SelfServiceCorporateDataContextType | null>(null);
